import Button from "@/components/Button";
import Dialog from "@/components/Dialog";
import type { ElectionPastPresidentAssigneeNode } from "../../queries";

export type RemovePastPresidentDialogProps = {
  open: boolean;
  assignee: ElectionPastPresidentAssigneeNode | null;
  saving?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export default function RemovePastPresidentDialog({
  open,
  assignee,
  saving = false,
  onClose,
  onConfirm
}: RemovePastPresidentDialogProps) {
  const name = assignee?.name ?? "this Past President";

  return (
    <Dialog
      open={open}
      onClosed={onClose}
      headline="Remove Past President"
      className="w-[490px] max-w-[95vw]"
      disableClose={saving}
      actions={
        <>
          <Button variant="text" onClick={onClose} disabled={saving} testId="remove-past-president-dialog-cancel">
            Cancel
          </Button>
          <Button
            variant="filled"
            theme="error"
            trailingIcon={false}
            icon="delete"
            onClick={onConfirm}
            loading={saving}
            testId="remove-past-president-dialog-confirm"
          >
            Remove
          </Button>
        </>
      }
    >
      <p className="text-body-medium">Are you sure you want to remove {name} from the Past Presidents roster?</p>
    </Dialog>
  );
}
